<template>
  <div>
    <section
      id="header"
      class="relative bg-gradient-to-br from-blue-200 to-white border-b-2 shadow-md"
    >
      <div class="container px-6 py-4 pb-[9rem] sm:px-44 sm:py-12 z-20">
        <h1 class="font-bold text-xl">Cek Status Pendaftaran</h1>
        <p>Masukkan email & password yang telah kamu daftarkan</p>
        <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4">
          <div class="sm:col-span-1">
            <label
              for="email"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Email</label
            >
            <div class="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                :value="email"
                @input="
                  errorEmail = '';
                  email = $event.target.value;
                "
                class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
              />

              <p class="text-red-500 text-sm" v-if="errorEmail">
                {{ errorEmail }}
              </p>
            </div>
          </div>
          <div class="sm:col-span-1">
            <label
              for="password"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Password</label
            >
            <div class="mt-2">
              <input
                id="password"
                name="password"
                type="password"
                :value="password"
                @input="
                  errorPassword = '';
                  password = $event.target.value;
                "
                class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
              />

              <p class="text-red-500 text-sm" v-if="errorPassword">
                {{ errorPassword }}
              </p>
            </div>
            <p class="text-sm text-gray-500 mt-2">
              <a href="#" class="text-primary-500 " @click="forgetPassword">Lupa Password?</a>
            </p>
          </div>
          <div class="sm:col-span-2 hidden sm:flex"></div>
          <div class="sm:col-span-2">
            <button
              type="submit"
              @click="handleCheckStatus"
              class="w-full bg-primary-500 hover:bg-primary-600 text-white py-2 px-4 rounded"
            >
              Cek Status
            </button>
          </div>
        </div>
        <div class="mt-4 text-red-500 text-sm">
          <p v-if="error">{{ error }}</p>
        </div>
      </div>
      <div class="w-36 sm:w-32 absolute bottom-0 right-6 sm:left-4">
        <FormIcon class="" />
      </div>
    </section>

    <!-- Modal Lupa Password -->
    <div
      v-if="showForgetPasswordModal"
      class="fixed inset-0 z-50 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center"
    >
      <!-- overlay -->
      <div
        aria-hidden="true"
        class="fixed inset-0 w-full h-full bg-black/50 cursor-pointer"
        @click="closeForgetPasswordModal"
      ></div>

      <!-- Modal -->
      <div
        class="relative w-full cursor-pointer pointer-events-none transition my-auto p-4"
      >
        <div
          class="w-full py-6 bg-white cursor-default pointer-events-auto relative rounded-xl mx-auto max-w-md"
        >
          <button
            type="button"
            class="absolute top-4 right-4 rtl:right-auto rtl:left-4"
            @click="closeForgetPasswordModal"
          >
            <svg
              xlinkTitle="Close"
              class="h-5 w-5 hover:rotate-180 transition-all ease-in-out duration-500 cursor-pointer text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span class="sr-only"> Close </span>
          </button>
          
          <!-- Modal Content -->
          <div class="px-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-4">
              Verifikasi Identitas
            </h3>
            <p class="text-sm text-gray-600 mb-6">
              Masukkan data diri untuk verifikasi dan reset password
            </p>
            
            <form @submit.prevent="handleForgetPassword">
              <div class="space-y-4">
                <div>
                  <label
                    for="nik"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    NIK
                  </label>
                  <div class="mt-2">
                    <input
                      id="nik"
                      name="nik"
                      type="text"
                      v-model="forgetPasswordForm.nik"
                      @input="clearForgetPasswordError('nik')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Masukkan NIK"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="forgetPasswordErrors.nik">
                      {{ forgetPasswordErrors.nik }}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    for="namaAyah"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Nama Ayah
                  </label>
                  <div class="mt-2">
                    <input
                      id="namaAyah"
                      name="namaAyah"
                      type="text"
                      v-model="forgetPasswordForm.namaAyah"
                      @input="clearForgetPasswordError('namaAyah')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Masukkan nama ayah"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="forgetPasswordErrors.namaAyah">
                      {{ forgetPasswordErrors.namaAyah }}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    for="namaIbu"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Nama Ibu
                  </label>
                  <div class="mt-2">
                    <input
                      id="namaIbu"
                      name="namaIbu"
                      type="text"
                      v-model="forgetPasswordForm.namaIbu"
                      @input="clearForgetPasswordError('namaIbu')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Masukkan nama ibu"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="forgetPasswordErrors.namaIbu">
                      {{ forgetPasswordErrors.namaIbu }}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    for="noHpOrtu"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Nomor HP Orang Tua
                  </label>
                  <div class="mt-2">
                    <input
                      id="noHpOrtu"
                      name="noHpOrtu"
                      type="tel"
                      v-model="forgetPasswordForm.noHpOrtu"
                      @input="clearForgetPasswordError('noHpOrtu')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Masukkan nomor HP orang tua"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="forgetPasswordErrors.noHpOrtu">
                      {{ forgetPasswordErrors.noHpOrtu }}
                    </p>
                  </div>
                </div>

                <div class="text-red-500 text-sm" v-if="forgetPasswordError">
                  <p>{{ forgetPasswordError }}</p>
                </div>

                <div class="flex space-x-3 pt-4">
                  <button
                    type="button"
                    @click="closeForgetPasswordModal"
                    class="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    :disabled="loadingForgetPassword"
                    class="flex-1 px-4 py-2 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-400 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <span v-if="loadingForgetPassword">Memproses...</span>
                    <span v-else>Verifikasi</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Reset Password -->
    <div
      v-if="showResetPasswordModal"
      class="fixed inset-0 z-50 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center"
    >
      <!-- overlay -->
      <div
        aria-hidden="true"
        class="fixed inset-0 w-full h-full bg-black/50 cursor-pointer"
        @click="closeResetPasswordModal"
      ></div>

      <!-- Modal -->
      <div
        class="relative w-full cursor-pointer pointer-events-none transition my-auto p-4"
      >
        <div
          class="w-full py-6 bg-white cursor-default pointer-events-auto relative rounded-xl mx-auto max-w-md"
        >
          <button
            type="button"
            class="absolute top-4 right-4 rtl:right-auto rtl:left-4"
            @click="closeResetPasswordModal"
          >
            <svg
              xlinkTitle="Close"
              class="h-5 w-5 hover:rotate-180 transition-all ease-in-out duration-500 cursor-pointer text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span class="sr-only"> Close </span>
          </button>
          
          <!-- Modal Content -->
          <div class="px-6">
            <h3 class="text-lg font-semibold text-gray-900 mb-4">
              Reset Password
            </h3>
            <p class="text-sm text-gray-600 mb-6">
              Masukkan password baru untuk akun Anda
            </p>
            
            <form @submit.prevent="handleResetPassword">
              <div class="space-y-4">
                <!-- Hidden token field -->
                <input
                  type="hidden"
                  v-model="resetPasswordForm.token"
                />

                <div>
                  <label
                    for="newPassword"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Password Baru
                  </label>
                  <div class="mt-2">
                    <input
                      id="newPassword"
                      name="newPassword"
                      type="password"
                      v-model="resetPasswordForm.password"
                      @input="clearResetPasswordError('password')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Masukkan password baru"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="resetPasswordErrors.password">
                      {{ resetPasswordErrors.password }}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    for="confirmPassword"
                    class="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Konfirmasi Password
                  </label>
                  <div class="mt-2">
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      type="password"
                      v-model="resetPasswordForm.confirmPassword"
                      @input="clearResetPasswordError('confirmPassword')"
                      class="block w-full bg-white rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      placeholder="Konfirmasi password baru"
                    />
                    <p class="text-red-500 text-sm mt-1" v-if="resetPasswordErrors.confirmPassword">
                      {{ resetPasswordErrors.confirmPassword }}
                    </p>
                  </div>
                </div>

                <div class="text-red-500 text-sm" v-if="resetPasswordError">
                  <p>{{ resetPasswordError }}</p>
                </div>

                <div class="flex space-x-3 pt-4">
                  <button
                    type="button"
                    @click="closeResetPasswordModal"
                    class="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    :disabled="loadingResetPassword"
                    class="flex-1 px-4 py-2 bg-primary-500 hover:bg-primary-600 disabled:bg-gray-400 text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <span v-if="loadingResetPassword">Memproses...</span>
                    <span v-else>Reset Password</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <section id="result" class="px-2 py-4 sm:px-44">
      <div
        v-if="Object.keys(user).length <= 0 && isSubmit"
        class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
      >
        <h2 class="text-3xl mx-auto col-span-6">
          Email & Password tidak sepertinya salah
        </h2>
        <div class="mx-auto w-xl col-span-full">
          <UserNotFoundVue />
        </div>
      </div>
      <Transition name="slide-fade">
        <div
          v-if="Object.keys(user).length > 0"
          class="mt-4 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
        >
          <div
            class="sm:col-span-6"
            v-if="user.status_berkas == 'Belum diverifikasi'"
          >
            <div
              class="bg-gray-100 border-l-4 border-yellow-500 text-gray-700 p-4 rounded-lg"
            >
              <p class="text-lg font-semibold">
                Status Berkas: Menunggu Verifikasi
              </p>
              <p>
                Pendaftaran kamu sedang dalam proses verifikasi oleh admin.
                Mohon tunggu beberapa saat lagi. Informasi lebih lanjut akan
                kami kirimkan melalui email yang terdaftar. Terima kasih atas
                kesabaranmu!
              </p>
            </div>
          </div>
          <div class="sm:col-span-6" v-if="user.status_berkas == 'Diterima'">
            <div
              class="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 rounded-lg"
            >
              <p class="text-lg font-semibold">Status Berkas: Diterima</p>
              <p>
                Selamat, pendaftaran kamu telah diterima. Untuk melanjutkan,
                mohon segera lakukan pembayaran dengan menekan tombol
                <i class="font-bold">Lunasi Pembayaran</i> dibawah. Pastikan
                pembayaran dilakukan tepat waktu untuk menyelesaikan proses
                pendaftaran.
              </p>
            </div>
          </div>
          <div class="sm:col-span-6" v-if="user.status_berkas == 'Ditolak'">
            <div
              class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-lg"
            >
              <p class="text-lg font-semibold">Status Berkas: Ditolak</p>
              <p>
                Kami mohon maaf, pendaftaran kamu ditolak karena masih ada
                berkas yang belum lengkap. Silakan lengkapi berkas yang
                dibutuhkan untuk melanjutkan proses pendaftaran. Berikut
                keterangan lebih lanjut:
              </p>
              <p class="font-bold mt-10">{{ user.keterangan_berkas }}</p>
            </div>
          </div>
          <div class="sm:col-span-1">
            <!-- photo profil -->
            <div class="w-full rounded-lg aspect-[3/4] border shadow-md">
              <img
                :src="apiUrl + user.pas_foto"
                alt="Profil"
                class="rounded-lg h-full object-cover w-full"
              />
            </div>
          </div>
          <div
            class="bg-white overflow-hidden shadow rounded-lg border sm:col-span-5"
          >
            <div class="px-4 py-5 sm:px-6">
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Profil
              </h3>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                NIK: {{ user.nik }}
              </p>
            </div>
            <div class="border-t border-gray-200 px-4 py-5 sm:p-0">
              <dl class="sm:divide-y sm:divide-gray-200">
                <div
                  class="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">
                    Nama Lengkap
                  </dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ user.nama_lengkap }}
                  </dd>
                </div>
                <div
                  class="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">Email</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ user.email }}
                  </dd>
                </div>
                <div
                  class="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">No. HP</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ user.no_hp }}
                  </dd>
                </div>
                <div
                  class="py-3 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
                >
                  <dt class="text-sm font-medium text-gray-500">Alamat</dt>
                  <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                    {{ user.alamat }}
                  </dd>
                </div>
              </dl>
              <button
                v-if="user.status_berkas == 'Diterima'"
                @click="pay"
                class="w-full px-4 py-2 bg-green-500 hover:bg-green-600 text-white"
              >
                Lunasi Pembayaran
              </button>
              <button
                v-if="user.status_berkas != 'Diterima'"
                @click="goToEditUser"
                :class="
                  user.status_berkas == 'Ditolak'
                    ? 'bg-red-500 hover:bg-red-600 text-white'
                    : 'bg-blue-500 hover:bg-blue-600 text-white'
                "
                class="w-full px-4 py-2"
              >
                Edit Berkas
              </button>
            </div>
          </div>
        </div>
      </Transition>
    </section>
    <!-- modal snap payment -->
    <div
      class="hidden inset-0 z-40 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center"
    >
      <!-- overlay -->
      <div
        aria-hidden="true"
        class="fixed inset-0 w-full h-full bg-black/50 cursor-pointer"
      ></div>

      <!-- Modal -->
      <div
        class="relative w-full cursor-pointer pointer-events-none transition my-auto p-4"
      >
        <div
          class="w-full py-2 bg-white cursor-default pointer-events-auto relative rounded-xl mx-auto max-w-sm"
        >
          <button
            type="button"
            class="absolute top-2 right-2 rtl:right-auto rtl:left-2"
          >
            <svg
              xlinkTitle="Close"
              class="h-4 w-4 hover:rotate-180 transition-all ease-in-out duration-500 cursor-pointer text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span class="sr-only"> Close </span>
          </button>
          <!-- skeleton -->
          <div class="py-4 w-60 sm:w-80 animate-pulse mx-auto">
            <div class="flex p-4 space-x-4 sm:px-8">
              <div
                class="flex-shrink-0 w-16 h-16 rounded-full bg-gray-300"
              ></div>
              <div class="flex-1 py-2 space-y-4">
                <div class="w-full h-3 rounded bg-gray-300"></div>
                <div class="w-5/6 h-3 rounded bg-gray-300"></div>
              </div>
            </div>
            <div class="p-4 space-y-4 sm:px-8">
              <div class="w-full h-4 rounded bg-gray-300"></div>
              <div class="w-full h-4 rounded bg-gray-300"></div>
              <div class="w-3/4 h-4 rounded bg-gray-300"></div>
            </div>
          </div>
          <!-- end skeleton -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormIcon from "@/components/svg/FormIcon.vue";
import UserNotFoundVue from "@/components/svg/UserNotFound.vue";
import { ref, onMounted } from "vue";
import axios from "axios";

import { useRouter } from "vue-router";
const apiUrl = process.env.VUE_APP_API_URL;
const midtransClient = process.env.VUE_APP_MIDTRANS_CLIENT;

const email = ref("");
const password = ref("");
const errorEmail = ref("");
const errorPassword = ref("");
const error = ref("");
const isSubmit = ref(false);
const loadingPayment = ref(false);

// Forget password modal variables
const showForgetPasswordModal = ref(false);
const loadingForgetPassword = ref(false);
const forgetPasswordError = ref("");
const forgetPasswordForm = ref({
  nik: "",
  namaAyah: "",
  namaIbu: "",
  noHpOrtu: ""
});
const forgetPasswordErrors = ref({
  nik: "",
  namaAyah: "",
  namaIbu: "",
  noHpOrtu: ""
});

// Reset password modal variables
const showResetPasswordModal = ref(false);
const loadingResetPassword = ref(false);
const resetPasswordError = ref("");
const resetPasswordForm = ref({
  token: "",
  password: "",
  confirmPassword: ""
});
const resetPasswordErrors = ref({
  password: "",
  confirmPassword: ""
});

const router = useRouter();
const user = ref({});

const goToEditUser = () => {
  router.push({
    name: "EditProfile",
    params: { token: user.value.token },
  });
};

// Forget password modal functions
const forgetPassword = () => {
  showForgetPasswordModal.value = true;
  // Reset form and errors
  forgetPasswordForm.value = {
    nik: "",
    namaAyah: "",
    namaIbu: "",
    noHpOrtu: ""
  };
  forgetPasswordErrors.value = {
    nik: "",
    namaAyah: "",
    namaIbu: "",
    noHpOrtu: ""
  };
  forgetPasswordError.value = "";
};

const closeForgetPasswordModal = () => {
  showForgetPasswordModal.value = false;
};

const clearForgetPasswordError = (field) => {
  forgetPasswordErrors.value[field] = "";
  forgetPasswordError.value = "";
};

const handleForgetPassword = async () => {
  // Reset errors
  forgetPasswordError.value = "";
  forgetPasswordErrors.value = {
    nik: "",
    namaAyah: "",
    namaIbu: "",
    noHpOrtu: ""
  };

  // Validation
  let hasError = false;
  
  if (!forgetPasswordForm.value.nik.trim()) {
    forgetPasswordErrors.value.nik = "NIK tidak boleh kosong";
    hasError = true;
  }
  
  if (!forgetPasswordForm.value.namaAyah.trim()) {
    forgetPasswordErrors.value.namaAyah = "Nama ayah tidak boleh kosong";
    hasError = true;
  }
  
  if (!forgetPasswordForm.value.namaIbu.trim()) {
    forgetPasswordErrors.value.namaIbu = "Nama ibu tidak boleh kosong";
    hasError = true;
  }
  
  if (!forgetPasswordForm.value.noHpOrtu.trim()) {
    forgetPasswordErrors.value.noHpOrtu = "Nomor HP orang tua tidak boleh kosong";
    hasError = true;
  }

  if (hasError) return;

  loadingForgetPassword.value = true;

  try {
    const formData = {
      nik: forgetPasswordForm.value.nik,
      nama_ayah: forgetPasswordForm.value.namaAyah,
      nama_ibu: forgetPasswordForm.value.namaIbu,
      no_hp_ortu: forgetPasswordForm.value.noHpOrtu
    };

    const response = await axios.post(apiUrl + "/user/forgot-password/", formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(response);
    
    // If response is successful (200), show reset password modal
    if (response.status === 200) {
      // Store token from response
      resetPasswordForm.value.token = response.data.token || response.data.reset_token || "";
      
      // Close verification modal and show reset password modal
      closeForgetPasswordModal();
      showResetPasswordModal.value = true;
    }
    
  } catch (error) {
    if (error.response && error.response.status === 400) {
      if (error.response.data.errors) {
        forgetPasswordError.value = error.response.data.msg || "Data tidak ditemukan atau tidak valid";
      }
      //   Object.keys(error.response.data.errors).forEach(key => {
      //     if (forgetPasswordErrors.value.hasOwnProperty(key)) {
      //       forgetPasswordErrors.value[key] = error.response.data.errors[key];
      //     }
      //   });
      // } else {
      //   forgetPasswordError.value = error.response.data.message || "Data tidak ditemukan atau tidak valid";
      // }
    } else {
      forgetPasswordError.value = "Terjadi kesalahan. Silakan coba lagi.";
    }
  } finally {
    loadingForgetPassword.value = false;
  }
};

// Reset password modal functions
const closeResetPasswordModal = () => {
  showResetPasswordModal.value = false;
  // Reset form
  resetPasswordForm.value = {
    token: "",
    password: "",
    confirmPassword: ""
  };
  resetPasswordErrors.value = {
    password: "",
    confirmPassword: ""
  };
  resetPasswordError.value = "";
};

const clearResetPasswordError = (field) => {
  resetPasswordErrors.value[field] = "";
  resetPasswordError.value = "";
};

const handleResetPassword = async () => {
  // Reset errors
  resetPasswordError.value = "";
  resetPasswordErrors.value = {
    password: "",
    confirmPassword: ""
  };

  // Validation
  let hasError = false;
  
  if (!resetPasswordForm.value.password.trim()) {
    resetPasswordErrors.value.password = "Password tidak boleh kosong";
    hasError = true;
  } else if (resetPasswordForm.value.password.length < 6) {
    resetPasswordErrors.value.password = "Password minimal 6 karakter";
    hasError = true;
  }
  
  if (!resetPasswordForm.value.confirmPassword.trim()) {
    resetPasswordErrors.value.confirmPassword = "Konfirmasi password tidak boleh kosong";
    hasError = true;
  } else if (resetPasswordForm.value.password !== resetPasswordForm.value.confirmPassword) {
    resetPasswordErrors.value.confirmPassword = "Konfirmasi password tidak cocok";
    hasError = true;
  }

  if (hasError) return;

  loadingResetPassword.value = true;

  try {
    const formData = {
      token: resetPasswordForm.value.token,
      password: resetPasswordForm.value.password,
      password_confirmation: resetPasswordForm.value.confirmPassword
    };

    const response = await axios.post(apiUrl + "/user/reset-password/", formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log(response);
    // Handle success
    alert("Password berhasil direset! Silakan login dengan password baru.");
    closeResetPasswordModal();
    
  } catch (error) {
    if (error.response && error.response.status === 400) {
      if (error.response.data.errors) {
        resetPasswordError.value = error.response.data.msg || "Token tidak valid atau sudah kadaluarsa";
      } 
    } else {
      resetPasswordError.value = "Terjadi kesalahan. Silakan coba lagi.";
    }
  } finally {
    loadingResetPassword.value = false;
  }
};

const handleCheckStatus = async () => {
  error.value = "";
  isSubmit.value = true;
  if (email.value === "") {
    errorEmail.value = "Email tidak boleh kosong";
  }
  if (password.value === "") {
    errorPassword.value = "Password tidak boleh kosong";
  }
  if (errorEmail.value || errorPassword.value) return false;
  try {
    const formData = {
      email: email.value,
      password: password.value,
    };

    const response = await axios.post(apiUrl + "/user/check/", formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    user.value = response.data;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      // Ambil pesan error dari backend
      error.value = error.response.data.errors || "An error occurred";
    } else {
      error.value = "An unexpected error occurred";
    }
  }
  // isSubmit.value = false;
};
const pay = async () => {
  loadingPayment.value = true;
  let token = await getSnapToken();
  if (token) {
    window.snap.pay(token, {
      onSuccess: function (result) {
        alert("Payment success!"); // Tampilkan notifikasi pembayaran berhasil
        console.log(result);
      },
      onPending: function (result) {
        alert("Payment is pending.");
        console.log(result);
      },
      onError: function (result) {
        alert("Payment failed!");
        console.log(result);
      },
      onClose: function () {
        alert("You closed the payment window without finishing.");
      },
    });
  }
  loadingPayment.value = false;
};
const getSnapToken = async () => {
  try {
    const formData = {
      id: user.value.id,
      email: user.value.email,
      nama_lengkap: user.value.nama_lengkap,
    };
    const response = await axios.post(
      apiUrl + "/user/get-payment-token/",
      formData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data.transaction_token;
  } catch (err) {
    console.log(err);
    return false;
  }
};
onMounted(() => {
  const script = document.createElement("script");
  script.src = "https://app.midtrans.com/snap/snap.js";
  console.log(midtransClient);
  script.setAttribute("data-client-key", midtransClient); // Midtrans Client Key
  document.head.appendChild(script);
});
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
